<template>
  <div>
    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-pt-10">
      <div class="tw-text-left tw-flex">
        <span>{{ isSetting ? 'เปลี่ยนแพ็คเกจ':'เลือก' }}จำนวนเอกสาร / เดือน</span>
        <span class="tw-w-48 tw--mt-2 tw-ml-5">
        <v-select
   :menu-props="{ bottom: true, offsetY: true }"
          v-model="select"
          v-on:change="setPackage"
          :items="numberOfDocument" filled
          label="จำนวนเอกสาร"
          dense
          outlined
          class="select-num-doc"
        ></v-select>
      </span>
      </div>
      <div class="tw-text-left md:tw-text-right tw-pb-5">
      <span v-on:click="annual = true; setPackage()"
            v-bind:class="[{'tw-text-light-green': annual}, 'tw-cursor-pointer']">รายปี</span> |
        <span v-on:click="annual = false; setPackage()"
              v-bind:class="[annual ? false: 'tw-text-light-green', 'tw-cursor-pointer']">รายเดือน</span>
      </div>
    </div>
    <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-gap-4 tw-text-left tw-pb-20">
      <div class="tw-bg-white tw-rounded-2xl tw-p-5 tw-shadow-md" v-if="this.paymentPlans">
        <img src="/images/packages/small.svg" class="tw-w-20" alt="small package">
        <div class="tw-my-8 tw-text-xl tw-font-bold">
          <span class="tw-w-2 tw-h-7 tw-bg-light-green tw-block tw-float-left tw-rounded-r-md tw--ml-5"></span>
          {{ this.paymentPlans[this.displayPackages[0]].nameTH }}
        </div>
        <div class="tw-text-light-green tw-font-bold tw-pt-2 tw-pb-10 tw-text-3xl">
              <span v-if="this.paymentPlans[this.displayPackages[0]].pricePerMonth && !this.annual">
              {{ (this.paymentPlans[this.displayPackages[0]].pricePerMonth / 100).toLocaleString() }}
              </span>
          <span v-if="!this.paymentPlans[this.displayPackages[0]].pricePerMonth && !this.annual">
              FREE
              </span>

          <span v-if="this.paymentPlans[this.displayPackages[0]].pricePerYear && this.annual">
              {{ (this.paymentPlans[this.displayPackages[0]].pricePerYear / 100).toLocaleString() }}
              </span>
          <span v-if="!this.paymentPlans[this.displayPackages[0]].pricePerYear && this.annual">
              FREE
              </span>

          <span v-if="this.paymentPlans[this.displayPackages[0]].pricePerMonth && !this.annual"
                class="tw-text-sm tw-text-gray-500">
                ต่อเดือน
              </span>
          <span v-if="this.annual" class="tw-text-sm tw-text-gray-500">
                ต่อปี
              </span>
        </div>
        <p class="tw-text-md tw-mb-1">เดือนแรกใช้ไม่อั้น เดือนถัดไปไม่เกิน
          {{ this.paymentPlans[this.displayPackages[0]].docsPerMonth.toLocaleString() }}
          ฉบับ/เดือน</p>
        <p class="tw-text-xs tw-text-gray-500 tw-m-0">
              <span v-if="(this.paymentPlans[this.displayPackages[0]].pricePerMonth && this.paymentPlans[this.displayPackages[0]].docsPerMonth)">
              เพียงฉบับละ ฿
              {{ !this.annual ? ((this.paymentPlans[this.displayPackages[0]].pricePerMonth / 100) / this.paymentPlans[this.displayPackages[0]].docsPerMonth).toFixed(2) : (((this.paymentPlans[this.displayPackages[0]].pricePerYear / 12) / 100) / this.paymentPlans[this.displayPackages[0]].docsPerMonth).toFixed(2) }}
              / ชำระง่ายผ่านช่องทางออนไลน์
              </span>
          <span v-if="!(!this.annual && this.paymentPlans[this.displayPackages[0]].pricePerMonth && this.paymentPlans[this.displayPackages[0]].docsPerMonth) || !(!this.annual && this.paymentPlans[this.displayPackages[0]].pricePerYear && this.paymentPlans[this.displayPackages[0]].docsPerMonth)">
              ไม่จำกัดระยะเวลาการใช้งาน ไม่ต้องกรอกบัตรเครดิต
              </span>
        </p>

        <div v-if="isSetting && onCheckHaveCurrentPackage"
             class="tw-mt-5 tw-text-center tw-py-2 tw-rounded-md tw-text-light-green tw-cursor-pointer"
             @click="()=> onSelect(this.displayPackages[0])">
          <img v-if="onCheckHaveCurrentPackage" src="/images/icons/icon_change.svg" alt="change" class="tw-inline tw-w-5"/>
          <span v-bind:class="[{'tw-text-gray-500': (onCheckEqualCurrentPackage(0))}]">
              เปลี่ยนแพ็คเกจ
          </span>
        </div>
        <div v-else
             class="tw-mt-5 tw-text-center tw-py-2 tw-rounded-md tw-border tw-border-light-green tw-text-light-green
              hover:tw-text-white hover:tw-bg-light-green tw-cursor-pointer"
             @click="()=> onSelect(this.displayPackages[0])">
          เลือก
        </div>
      </div>

      <div class="tw-bg-white tw-rounded-2xl tw-p-5 tw-shadow-md" v-if="this.paymentPlans">
        <img src="/images/packages/medium.svg" class="tw-w-20" alt="small package">
        <div class="tw-my-8 tw-text-xl tw-font-bold">
          <span class="tw-w-2 tw-h-7 tw-bg-light-yellow tw-block tw-float-left tw-rounded-r-md tw--ml-5"></span>
          {{ this.paymentPlans[this.displayPackages[1]].nameTH }}
        </div>
        <div class="tw-text-light-yellow tw-font-bold tw-pt-2 tw-pb-10 tw-text-3xl tw-relative tw-p-3">
          <span class="tw-text-sm tw-absolute tw-top-2 tw-left-0">฿</span>

          <span v-if="!this.annual">{{
              (this.paymentPlans[this.displayPackages[1]].pricePerMonth / 100).toLocaleString()
            }}</span>
          <span v-if="this.annual">{{
              (this.paymentPlans[this.displayPackages[1]].pricePerYear / 100).toLocaleString()
            }}</span>

          <span v-if="!this.annual" class="tw-text-sm tw-text-gray-500">ต่อเดือน</span>
          <span v-if="this.annual" class="tw-text-sm tw-text-gray-500">
                ต่อปี
              </span>
        </div>
        <p class="tw-text-md tw-mb-1">เอกสาร
          {{ this.paymentPlans[this.displayPackages[1]].docsPerMonth.toLocaleString() }} ฉบับ / เดือน
        </p>
        <p class="tw-text-xs tw-text-gray-500 tw-m-0">เพียงฉบับละ
          ฿{{ !this.annual ? ((this.paymentPlans[this.displayPackages[1]].pricePerMonth / 100) / this.paymentPlans[this.displayPackages[1]].docsPerMonth).toFixed(2) : (((this.paymentPlans[this.displayPackages[1]].pricePerYear / 12) / 100) / this.paymentPlans[this.displayPackages[1]].docsPerMonth).toFixed(2) }} /
          ชำระง่ายผ่านช่องทางออนไลน์</p>
        <div v-if="isSetting && onCheckHaveCurrentPackage"
             class="tw-mt-5 tw-text-center tw-py-2 tw-rounded-md tw-text-light-green tw-cursor-pointer"
             @click="()=> onSelect(this.displayPackages[1])">
          <img v-if="onCheckHaveCurrentPackage" src="/images/icons/icon_change.svg" alt="change" class="tw-inline tw-w-5"/>
          <span v-bind:class="[{'tw-text-gray-500': (onCheckEqualCurrentPackage(1))}]">
              เปลี่ยนแพ็คเกจ
          </span>
        </div>
        <div v-else
             class="tw-mt-5 tw-text-center tw-py-2 tw-rounded-md tw-border tw-border-light-green tw-text-light-green
              hover:tw-text-white hover:tw-bg-light-green tw-cursor-pointer"
             @click="()=> onSelect(this.displayPackages[1])">
          เลือก
        </div>
      </div>

      <div class="tw-bg-white tw-rounded-2xl tw-p-5 tw-shadow-md" v-if="this.paymentPlans">
        <img src="/images/packages/large.svg" class="tw-w-20" alt="small package">
        <div class="tw-my-8 tw-text-xl tw-font-bold">
          <span class="tw-w-2 tw-h-7 tw-bg-light-blue tw-block tw-float-left tw-rounded-r-md tw--ml-5"></span>
          {{ this.paymentPlans[this.displayPackages[2]].nameTH }}
        </div>
        <div class="tw-text-light-blue tw-font-bold tw-pt-2 tw-pb-10 tw-text-3xl tw-relative tw-p-3">
          <span class="tw-text-sm tw-absolute tw-top-2 tw-left-0">฿</span>
          <span v-if="!this.annual">{{
              (this.paymentPlans[this.displayPackages[2]].pricePerMonth / 100).toLocaleString()
            }}</span>
          <span v-if="this.annual">{{
              (this.paymentPlans[this.displayPackages[2]].pricePerYear / 100).toLocaleString()
            }}</span>

          <span v-if="!this.annual" class="tw-text-sm tw-text-gray-500">ต่อเดือน</span>
          <span v-if="this.annual" class="tw-text-sm tw-text-gray-500">
                ต่อปี
              </span>
        </div>
        <p class="tw-text-md tw-mb-1">เอกสาร
          {{ this.paymentPlans[this.displayPackages[2]].docsPerMonth.toLocaleString() }} ฉบับ / เดือน
        </p>
        <p class="tw-text-xs tw-text-gray-500 tw-m-0">เพียงฉบับละ
          ฿{{ !this.annual ? ((this.paymentPlans[this.displayPackages[2]].pricePerMonth / 100) / this.paymentPlans[this.displayPackages[2]].docsPerMonth).toFixed(2) : (((this.paymentPlans[this.displayPackages[2]].pricePerYear / 12) / 100) / this.paymentPlans[this.displayPackages[2]].docsPerMonth).toFixed(2) }}/
          ชำระง่ายผ่านช่องทางออนไลน์</p>
        <div v-if="isSetting && onCheckHaveCurrentPackage"
             class="tw-mt-5 tw-text-center tw-py-2 tw-rounded-md tw-text-light-green tw-cursor-pointer"
             @click="()=> onSelect(this.displayPackages[2])">
          <img v-if="onCheckHaveCurrentPackage" src="/images/icons/icon_change.svg" alt="change" class="tw-inline tw-w-5"/>
          <span v-bind:class="[{'tw-text-gray-500': (onCheckEqualCurrentPackage(2))}]">
              เปลี่ยนแพ็คเกจ
          </span>
        </div>
        <div v-else
             class="tw-mt-5 tw-text-center tw-py-2 tw-rounded-md tw-border tw-border-light-green tw-text-light-green
              hover:tw-text-white hover:tw-bg-light-green tw-cursor-pointer"
             @click="()=> onSelect(this.displayPackages[2])">
          เลือก
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'PackageOption',
  props: ['onSelectPackage', 'currentPackage', 'isSetting'],
  computed: mapState({
    paymentPlans: state => state.paymentPlans.list,
    refCodeObject: state => state.companies.refCodeObject,
  }),
  created() {
    this.$store.dispatch('paymentPlans/getList');
  },
  methods: {
    setPackage: function () {
      let displayPackages = []
      if (this.annual) {
        displayPackages = this.packagesAnnual.slice(this.numberOfDocument.indexOf(this.select), this.numberOfDocument.indexOf(this.select) + 3)
      } else {
        displayPackages = this.packages.slice(this.numberOfDocument.indexOf(this.select), this.numberOfDocument.indexOf(this.select) + 3)
      }

      if(this.refCodeObject) {
        displayPackages = displayPackages.map(packageText => {
          if(this.refPackage.some(ref => packageText === ref)){
            return packageText + '_ref'
          }
          return packageText
        })
      }

      this.displayPackages = displayPackages
    },
    onSelect: function (packageName) {
      if(this.onSelectPackage){
        if(this.onCheckHaveCurrentPackage() === packageName) return
        this.onSelectPackage(packageName, this.refCodeObject)
      }
    },
    onCheckHaveCurrentPackage: function () {
      return this.currentPackage && this.currentPackage['id']
    },
    onCheckEqualCurrentPackage: function (index) {
      return this.currentPackage ? this.currentPackage['id'] === this.displayPackages[index] : false
    },
  },
  data: function () {
    return {
      'displayPackages': ['free_month', 's_month', 'm_month'],
      'packages': ['free_month', 's_month', 'm_month', 'l_month', 'xl_month', 'xxl_month', 'xxxl_month', 'retail_month', 'enterprise_month'],
      'packagesAnnual': ['free_month', 's_year', 'm_year', 'l_year', 'xl_year', 'xxl_year', 'xxxl_year', 'retail_year', 'enterprise_year'],
      'refPackage': ['free_month', 's_year', 'm_year', 'l_year', 'xl_year','s_month', 'm_month', 'l_month', 'xl_month'],
      'annual': false,
      'select': 'น้อยกว่า 100',
      'numberOfDocument': [
        'น้อยกว่า 100',
        'น้อยกว่า 500',
        'น้อยกว่า 1,000',
        'น้อยกว่า 3,000',
        'น้อยกว่า 7,000',
        'น้อยกว่า 10,000',
        'มากกว่า 15,000',
      ]
    }
  },
  watch:{
    refCodeObject: {
      handler: function () {
          this.setPackage();
      }
    }
  }
}

</script>
<style lang="scss">
.select-num-doc .v-input__slot{
  background-color: white !important;
}
</style>
